module.exports = __webpack_public_path__ + "static/media/icon_facebook.93fb5c18.svg";